import { useState } from 'react';
import logo from '../../assets/elby.png';
import bwgoCover from '../../assets/beforewegetolderCover.png';
import inBetweenCover from '../../assets/theinbetweencover.jpg';
import './header.css';
import { Link } from 'react-router-dom';

const dropdownWrapperStyle = {
  position: 'absolute',
  top: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  paddingTop: '10px',
  zIndex: 1000,
};

const dropdownStyle = {
  background: '#fff',
  borderRadius: '14px',
  padding: '6px',
  boxShadow: '0 8px 30px rgba(0,0,0,0.1), 0 2px 8px rgba(0,0,0,0.05)',
  border: '1px solid rgba(0,0,0,0.07)',
  width: '230px',
  display: 'flex',
  flexDirection: 'column',
};

const bookTitleStyle = {
  fontWeight: 600,
  fontSize: '0.85rem',
  color: 'var(--text-color)',
  margin: 0,
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
};

function BookCard({ to, cover, title }) {
  const [hovered, setHovered] = useState(false);
  const [pressed, setPressed] = useState(false);

  const cardStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 10px',
    borderRadius: '9px',
    cursor: 'pointer',
    textDecoration: 'none',
    border: 'none',
    transition: 'background 0.2s ease, transform 0.15s ease',
    background: hovered ? 'rgba(0,0,0,0.04)' : 'transparent',
    transform: pressed ? 'scale(0.97)' : 'scale(1)',
  };

  const coverWrapperStyle = {
    position: 'relative',
    flexShrink: 0,
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: hovered ? '0 6px 16px rgba(0,0,0,0.28)' : '0 2px 5px rgba(0,0,0,0.18)',
    transition: 'box-shadow 0.25s ease, transform 0.25s ease',
    transform: hovered ? 'translateY(-2px) scale(1.05)' : 'translateY(0) scale(1)',
  };

  const coverStyle = {
    width: '38px',
    height: '57px',
    objectFit: 'cover',
    display: 'block',
    transition: 'filter 0.25s ease',
    filter: hovered ? 'brightness(1.05)' : 'brightness(1)',
  };

  const shimmerStyle = {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(135deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0) 60%)',
    opacity: hovered ? 1 : 0,
    transition: 'opacity 0.25s ease',
    pointerEvents: 'none',
    borderRadius: '4px',
  };

  return (
    <Link
      to={to}
      style={cardStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => { setHovered(false); setPressed(false); }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
    >
      <div style={coverWrapperStyle}>
        <img src={cover} alt={title} style={coverStyle} />
        <div style={shimmerStyle} />
      </div>
      <h4 style={bookTitleStyle}>{title}</h4>
    </Link>
  );
}

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [booksOpen, setBooksOpen] = useState(false);

  return (
    <>
      <header className="header">
        <Link to="/">
        <img src={logo} alt="Logo" className="logo" />
        </Link>

        {/* Desktop Nav */}
        <nav className="nav desktop-nav">
          <Link to="/">Home</Link>

          <div
            className="book-dropdown"
            onMouseEnter={() => setBooksOpen(true)}
            onMouseLeave={() => setBooksOpen(false)}
            style={{ position: 'relative' }}
          >
            <button className="dropbtn">My Books</button>

            {booksOpen && (
              <div style={dropdownWrapperStyle}>
                <div style={dropdownStyle}>
                  <BookCard to="/before-we-get-older" cover={bwgoCover} title="Before We Get Older" />
                  <div className="book-dropdown-divider" />
                  <BookCard to="/the-in-between" cover={inBetweenCover} title="The In-Between" />
                </div>
              </div>
            )}
          </div>

          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/joinpage">
            <button className="cta-button">Join Me</button>
          </Link>
        </nav>

        {/* Mobile Actions */}
        <div className="mobile-actions">
          <button
            className="hamburger-icon"
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          >
            <span className="ham-line" />
            <span className="ham-line ham-line--mid" />
            <span className="ham-line" />
          </button>
        </div>
      </header>

      {/* Overlay */}
      <div
        className={`mobile-overlay ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Slide-in Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <button className="close-menu" onClick={() => setMenuOpen(false)} aria-label="Close menu">
          ✕
        </button>

        <div className="mobile-menu-logo-wrap">
        <div className="mobile-menu-logo-wrap">
  <Link to="/" onClick={() => setMenuOpen(false)}>
    <img src={logo} alt="Logo" className="mobile-menu-logo" />
  </Link>
</div>
        </div>

        <nav className="mobile-nav-links">
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>

          <div className="mobile-books-section">
            <span className="mobile-books-label">My Books</span>
            <div className="mobile-book-cards">
              <Link to="/before-we-get-older" className="mobile-book-card" onClick={() => setMenuOpen(false)}>
                <img src={bwgoCover} alt="Before We Get Older" className="mobile-book-cover" />
                <span>Before We Get Older</span>
              </Link>
              <Link to="/the-in-between" className="mobile-book-card" onClick={() => setMenuOpen(false)}>
                <img src={inBetweenCover} alt="The In-Between" className="mobile-book-cover" />
                <span>The In-Between</span>
              </Link>
            </div>
          </div>

          <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
        </nav>

        <Link to="/joinpage" className="mobile-cta" onClick={() => setMenuOpen(false)}>
          Join Me
        </Link>
      </div>
    </>
  );
}

export default Header;